import { render, staticRenderFns } from "./PaymentRequestDetail.vue?vue&type=template&id=38b71b4b"
import script from "../../controllers/payment/payment-request-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment/payment-request-detail.js?vue&type=script&lang=js&external"
import style0 from "./PaymentRequestDetail.vue?vue&type=style&index=0&id=38b71b4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports